<template>
  <div style="overflow-x: hidden">
    <h1 style="width: 0; height: 0; opacity: 0; visibility: hidden; overflow: hidden; margin: 0">
      {{ $t("footer.fot5") }}
    </h1>

    <section class="breadcrumb_nav">
      <div class="breadcrumb_nav_img relative">
        <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1668499027_21.jpg" alt="img" />
        <h2 class="breadcrumb_nav_title text-center hidden-xs">{{ $t("footer.fot5") }}</h2>
      </div>

      <div class="breadcrumb_nav_wrap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb_nav_box">
                <ul class="breadcrumb_nav_list">
                  <li>
                    <a href="https://www.midonkey.com/">{{ $t("common.home") }}</a>
                  </li>
                  <li>
                    <i class="fa fa-angle-double-right"></i>
                    <span> {{ $t("footer.fot5") }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 页面样式 -->
    <link rel="stylesheet" href="/css/Album-6.css" />

    <main>
      <section class="product-list galleries-ibox">
        <div class="container">
          <div class="col-lg-6 col-xs-12">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900477_Ebike-Design-Department.png">
                <img alt="Ebike Design Department" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900477_Ebike-Design-Department.png" loading="lazy" width="100%" height="390" />
              </a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item1") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xs-6">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900273_Ebike-Assembly-Line-2.jpg">
                <img alt="Ebike Assembly Line" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900273_Ebike-Assembly-Line-2.jpg" loading="lazy" width="100%" height="200" />
              </a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item2") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xs-6">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900312_Ebike-Assembly-Line.jpg">
                <img alt="Ebike Assembly Line" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900312_Ebike-Assembly-Line.jpg" loading="lazy" width="100%" height="200" />
              </a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item3") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xs-6">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900183_Bike-Wheel-Assembly-Area.jpg">
                <img alt="Bike Wheel Assembly Area" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900183_Bike-Wheel-Assembly-Area.jpg" loading="lazy" width="100%" height="200" />
              </a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item4") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xs-6">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900506_Ebike-Materials-Preparation-Area.jpg">
                <img alt="Ebike Materials Preparation Area" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900506_Ebike-Materials-Preparation-Area.jpg" loading="lazy" width="100%" height="200" />
              </a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item5") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xs-6">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900233_Ebike-Assembling.JPG">
                <img alt="Ebike Assembling" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900233_Ebike-Assembling.JPG" loading="lazy" width="100%" height="200" />
              </a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item6") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xs-6">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900654_Semi-finished-Ebikes.jpg">
                <img alt="Semi-finished Ebikes" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900654_Semi-finished-Ebikes.jpg" loading="lazy" width="100%" height="200" />
              </a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item7") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xs-6">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900603_Ebike-Testing-Area.jpg">
                <img alt="Ebike Testing Area" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900603_Ebike-Testing-Area.jpg" loading="lazy" width="100%" height="200" />
              </a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item8") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xs-6">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900540_Ebike-Packing-Area-2.png">
                <img alt="Ebike Packing Area" src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900540_Ebike-Packing-Area-2.png" loading="lazy" width="100%" height="200" />
              </a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item9") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xs-12">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900569_Ebike-Packing-Area.png"> <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900569_Ebike-Packing-Area.png" loading="lazy" width="100%" height="390" /></a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item10") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xs-6">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900727_Warehouse.jpg"> <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900727_Warehouse.jpg" loading="lazy" width="100%" height="200" /></a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item11") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xs-6">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900452_Ebike-Bulk-Shipment.jpg"> <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900452_Ebike-Bulk-Shipment.jpg" loading="lazy" width="100%" height="200" /></a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item12") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xs-6">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900628_Salt-Spray-Test-Room.JPG"> <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900628_Salt-Spray-Test-Room.JPG" loading="lazy" width="100%" height="200" /></a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item13") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xs-6">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900395_Ebike-Battery-Assembly-Line.jpg"> <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900395_Ebike-Battery-Assembly-Line.jpg" loading="lazy" width="100%" height="200" /></a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item14") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xs-6">
            <div class="thumbnail">
              <a class="fancy-box" data-fancybox="gallery" href="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900114_Battery-Aging-Test.jpg"> <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/factory/image_1667900114_Battery-Aging-Test.jpg" loading="lazy" width="100%" height="200" /></a>
              <div class="caption">
                <h3>
                  <span class="fancy-box" href="javascript:;">{{ $t("factory.item15") }}</span>
                </h3>
                <div class="desc" style="color: #fff; margin-top: 10px"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="section-margin-1x">
        <div class="container">
          <hr />
        </div>
      </div>

      <div class="section-margin-2x"></div>
    </main>
  </div>
</template>
<script>
export default {}
</script>
<style scoped>
main .section-head h2 {
  font-size: 25px;
  margin-top: 0;
}

main .section-head h2:after {
  background-color: var(--main-theme-color);
}

main .thumbnail h3 {
  height: auto;
}

main .thumbnail .caption span.fancy-box {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  vertical-align: middle;
  font-size: 20px;
  line-height: 24px;
  height: 48px;
}

main .recommend-section .thumbnail-desc {
  overflow: hidden;
  display: -webkit-box !important;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  font-size: 16px;
  line-height: 23px;
  margin-bottom: 20px;
  height: 69px;
}

main .galleries-ibox {
  padding-top: 70px;
}

@media only screen and (max-width: 991px) {
  main .galleries-ibox {
    padding-top: 60px;
  }
}

@media only screen and (max-width: 767px) {
  main .galleries-ibox {
    padding-top: 50px;
  }
}

@media only screen and (max-width: 1200px) {
  main .col-lg-3 .thumbnail a,
  main .col-lg-6 .thumbnail a {
    padding-bottom: 0;
  }
}
</style>
